import React, { useEffect, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components'
import { accessibilityColors, borderGrey4, themeColor } from '@edulastic/colors'
import { MenuTrigger, Popover, Button } from 'react-aria-components'
import { IconAddToFolder } from '@edulastic/icons'
import {
  toggleMoveItemsFolderAction,
  toggleRemoveItemsFolderAction,
} from '../../../src/actions/folder'
import { onEnterKeyPressHandler } from '../../../../common/utils/helpers'

const AddRemoveTest = ({
  testDetail,
  toggleAddItemModal,
  toggleRemovalModal,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, setIsOpen])

  const toggleMoveFolderModal = () => {
    if (toggleAddItemModal && !isEmpty(testDetail)) {
      toggleAddItemModal({
        items: [testDetail],
        isOpen: true,
      })
    }
  }

  const openRemoveItemsFromFolderModal = () => {
    if (toggleRemovalModal && !isEmpty(testDetail)) {
      toggleRemovalModal({
        items: [testDetail],
        isOpen: true,
      })
    }
  }

  return (
    <MenuTrigger>
      <span onMouseEnter={() => setIsOpen(true)}>
        <StyledButton
          aria-label={`Add or Remove ${testDetail?.name || ''} from Folder`}
          aria-expanded={isOpen}
          aria-haspopup="true"
          onKeyDown={(e) => onEnterKeyPressHandler(e, () => setIsOpen(true))}
        >
          <IconAddToFolder height="18" width="19.13" />
        </StyledButton>
      </span>
      <StyledPopover isOpen={isOpen} onOpenChange={setIsOpen}>
        <ButtonContainer>
          <StyledActionButton
            data-cy="add-to-folder"
            onPress={toggleMoveFolderModal}
          >
            Add to Folder
          </StyledActionButton>
          <StyledActionButton
            data-cy="remove-from-folder"
            onPress={openRemoveItemsFromFolderModal}
          >
            Remove from Folder
          </StyledActionButton>
        </ButtonContainer>
      </StyledPopover>
    </MenuTrigger>
  )
}

const enhance = compose(
  connect(null, {
    toggleRemovalModal: toggleRemoveItemsFolderAction,
    toggleAddItemModal: toggleMoveItemsFolderAction,
  })
)
export default enhance(AddRemoveTest)

const StyledButton = styled(Button)`
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  min-width: 33px;
  height: 33px;
  max-height: 33px;
  padding: 0;
  border-radius: 50%;
  border: 1.2px solid ${themeColor};
  &:focus {
    outline: 2px solid ${accessibilityColors.theme.blueHover};
    outline-offset: -2px;
  }
`

const StyledPopover = styled(Popover)`
  border: 1px solid ${borderGrey4};
  border-radius: 4px;
  background-color: white;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledActionButton = styled(Button)`
  padding: 10px 20px;
  background-color: transparent;
  border: none;
  text-align: left;
  width: 100%;
  font-size: 14px;
  font-family: inherit;

  &:hover,
  &:focus {
    background-color: ${accessibilityColors.theme.blueHover};
    color: white;
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${accessibilityColors.theme.blue};
    outline-offset: -2px;
  }

  cursor: pointer;
`
